import React from 'react';

import { Text } from 'react-native';
import styled from 'styled-components/native';

import { FOHFonts } from '../../ingredients';

interface FOHBlackTagProps {
  label: string;
  style?: any;
}

export const FOHBlackTag = (props: FOHBlackTagProps) => (
  <BlackTagText style={{ ...props.style }}>{props.label}</BlackTagText>
);

const BlackTagText = styled(Text)`
  font-family: ${FOHFonts.MEDIUM}
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
  color: #ffffff;
  background-color: #000000;
  justify-content: center;
  text-align: center;
  line-height: 22px;
  font-size: 12px;
  word-break: break-word;
  border-radius: 100px;
  padding-top: 2px;
  padding-right: 9px;
  padding-left: 9px;
`;
